<template>
  <b-modal
    :id="`mc-modal-remove-order-${deliveryOrder?.id}-${pointId}`"
    class="mc-modal"
    :title="$t('fleetTask.removeDeliveryModal.title')"
    size="md"
    centered
    scrollable
  >
    <div class="card-body p-2">
      <p>
        {{ $t('fleetTask.removeDeliveryModal.confirmationText') }}
        <strong>{{ deliveryOrder?.number }}</strong
        >?
      </p>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('fleetTask.removeDeliveryModal.action.no')"
          @click="cancel()"
        />
        <McButton
          variant="primary"
          :text="$t('fleetTask.removeDeliveryModal.action.yes')"
          @click="handleRemoveOrder"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

import * as FleetTaskDeliveryOrder from '@/services/rest-api/lib/fleet-task/delivery-order'
import * as FleetTask from '@/services/rest-api/lib/fleet-task/fleet-task'
import { EventBus } from '@/router/views/fleet-task/lib/event-bus'

import toastErrors from '@/router/views/fleet-task/lib/constants/toast-errors'
import { removeOrderError } from '../lib/constants/error-message-mappings'
import { errorCodeToastMap } from '../lib/constants/error-code-mappings'

export default {
  components: {
    McButton,
  },
  props: {
    deliveryOrder: {},
    pointId: {},
  },
  methods: {
    async handleRemoveOrder() {
      await this.$store.dispatch('fleetTask/setIsLoadingGlobalDelay', true)
      this.$store.dispatch('fleetTask/setIsInitial', false)
      const res = await FleetTaskDeliveryOrder.remove(this.$route.params.id, this.deliveryOrder.id)

      if (res?.errors) {
        let message = toastErrors['delivery/failed-to-delete']

        if (res?.status == 400) {
          const issueCodes = res.errors_v2.issues.map((issue) => issue.code)

          for (const code of issueCodes) {
            if (errorCodeToastMap[code]) {
              const matches = res.message.match(/FO-\d+/g)
              const fleetTaskId = matches && matches.length > 0 ? matches[0] : ''
              message = `${this.$t(
                'fleetTask.removeDeliveryModal.toast.failedAssignedUntil.beforeNumber'
              )}<strong>${this.deliveryOrder.number}</strong>${this.$t(
                'fleetTask.removeDeliveryModal.toast.failedAssignedUntil.beforeFleetTask'
              )}<strong>${fleetTaskId}</strong>`
              break
            }
          }

          if (!message) {
            message = toastErrors[removeOrderError[res.message] || removeOrderError.default]
          }
        }

        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                html: message,
              },
            ],
          },
        })
        this.$bvModal.hide(`mc-modal-remove-order-${this.deliveryOrder.id}-${this.pointId}`)
        EventBus.$emit('refetch-sequence')
        return
      }

      if (this.$parent.$parent.hasVendor) {
        await FleetTask.update(this.$route.params.id, { vendor_id: null })
        EventBus.$emit('update-has-vendor', false)
      }

      this.$router.replace({ hash: `POINT_${this.pointId}` })
      const query = {
        ...this.$route.query,
      }

      const clickListener = () => {
        this.$router.push({
          name: 'Delivery Detail',
          params: { id: this.deliveryOrder.id },
          query,
        })
      }

      this.$mcToast.success({
        component: 'McToastDynamicBody',
          props: {
            contents: [
            {
              tag: 'span',
              text: this.$t('fleetTask.removeDeliveryModal.toast.success'),
            },
            {
              tag: 'a',
              html: `<strong>${this.deliveryOrder.number}</strong>`,
              class: '__link',
              listeners: { click: clickListener },
            },
          ],
        },
      })

      this.$bvModal.hide(`mc-modal-remove-order-${this.deliveryOrder.id}-${this.pointId}`)
      EventBus.$emit('refetch-sequence')
    },
  },
}
</script>
